module.exports = __webpack_public_path__ + "images/menu-task.svg?f7f35dd0ac324e8d5197bf1941c69168";